import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../../StyleComponents'
import { EBikeImage } from '../../../images'
import { ImageContainer, BulletList, BulletListItem } from '../../../styles'
import { LIST_ITEMS_1, LIST_ITEMS_2, LIST_ITEMS_3 } from './constants'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'
import { isWebview } from '../../../../../../utilities/userAgent'
import { loadUrl } from '../../../../../../webview'

const stepName = 'EBikes'

export const EBikes = () => {
  const getAnchorProps = (item): React.HTMLProps<HTMLAnchorElement> => {
    let anchorProps = {}

    if (isWebview()) {
      anchorProps = {
        ...anchorProps,
        onClick: () => {
          loadUrl(item.link)
        },
      }
    } else {
      anchorProps = {
        ...anchorProps,
        target: '_blank',
        href: item.link,
      }
    }

    return anchorProps
  }

  return (
    <SectionContainer>
      <ImageContainer>
        <EBikeImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__heading__eBikes)}
      </Text>
      <ContentText>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__description__eBikes)}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__sub_heading1__eBikes)}
      </Text>
      <BulletList>
        {LIST_ITEMS_1.map((item, index) => (
          <BulletListItem key={`${stepName}_LIST_ITEMS_1_${index}`} mb="XSmall">
            <ContentText>{item}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__sub_heading2__eBikes)}
      </Text>
      <BulletList>
        {LIST_ITEMS_2.map((item, index) => (
          <BulletListItem key={`${stepName}_LIST_ITEMS_2_${index}`} mb="XSmall">
            <ContentText>{item}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__sub_heading3__eBikes)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step3__au__sub_heading3__description__eBikes
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__sub_heading4__eBikes)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step3__au__sub_heading4__description__eBikes
        )}
      </ContentText>
      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_bike_step3__au__sub_heading5__eBikes)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step3__au__sub_heading5__description__eBikes
        )}
      </ContentText>
      <BulletList>
        {LIST_ITEMS_3.map((item, index) => (
          <BulletListItem key={`${stepName}_LIST_ITEMS_3_${index}`} mb="XSmall">
            <Text
              style={{ textDecoration: 'underline' }}
              color={Text.Colors.SystemGrey80}
              tag={'a'}
              {...getAnchorProps(item)}
            >
              <ContentText>{item.text}</ContentText>
            </Text>
          </BulletListItem>
        ))}
      </BulletList>
    </SectionContainer>
  )
}
